import React, { useState, useEffect } from "react";
import "./tictactoe.css";
import logo from "../../../assets/images/coinlogo.png";
import useUserInfo from "../../../Hooks/useUserInfo";
import cancelIcon from "../../../assets/Task/cancelicon.svg";
import { userGameRewards } from "../../../apis/user";
import { useAudio } from "../../../Providers/AudioProvider";
import task from "../../Task/Task";
import { logPageView } from "../../../components/analytics";
import Swal from "sweetalert2";

const TicTacToe = () => {
  const { userDetails, updateUserInfo, watchScreen, updatewatchScreenInfo } =
    useUserInfo();
  const userId = userDetails?.userDetails?.telegramId;
  const [board, setBoard] = useState(Array(9).fill(null));
  const [isPlayerTurn, setIsPlayerTurn] = useState(true);
  const [winner, setWinner] = useState(null);
  const [gameFinished, setGameFinished] = useState(false);
  const [score, setScore] = useState(0);
  const [roundsPlayed, setRoundsPlayed] = useState(
    JSON.parse(localStorage.getItem(`TicTacToeRound_${userId}`)) || 0
  );

  const [isPlayed, setIsPlayed] = useState(false);
  const [xWins, setXWins] = useState(0);
  const [oWins, setOWins] = useState(0);
  const [winningCombination, setWinningCombination] = useState([]);
  const [isStrikeThrough, setIsStrikeThrough] = useState(false);
  const today = new Date().toDateString();
  const playClick = useAudio();
  const IsPointsReached =
    watchScreen?.LoginMessage ==
    "You have already reached the maximum rewards limit"
      ? true
      : false;
  const handleApiResponse = async (points, onSuccess) => {
    updateUserInfo((prev) => ({
      ...prev,
      isLoading: true,
    }));
    try {
      const apiData = {
        gamePoints: points,
        gameType: "TicTacToe",
        chancesToPlayed:1,
      };
      const res = await userGameRewards(apiData); // Replace with your actual API call
      if (res) {
        updateUserInfo((prev) => ({
          ...prev,
          isLoading: false,
        }));
        updatewatchScreenInfo((prev) => ({
          ...prev,
          LoginMessage: res?.message,
        }));
        setGameFinished(true);
        localStorage.setItem(
          `TicTacToeRound_${userId}`,
          Number(roundsPlayed) + 1
        );
        if (roundsPlayed >= 2) {
          setIsPlayed(true);
          localStorage.setItem(`TicTacToeRound_${userId}`, 0);
          localStorage.setItem(
            `playedStatusTicToe_${userId}`,
            JSON.stringify({ isPlayed: true, date: today })
          );
        }
        // Call the success callback if provided
        if (onSuccess) {
          onSuccess();
        }
      }
      else {
        updateUserInfo((prev) => ({
          ...prev,
          isLoading: false,
        }));
        if (onSuccess) {
          onSuccess();
        }
      }
    } catch (error) {
      console.error("API call failed:", error);
      updateUserInfo((prev) => ({
        ...prev,
        isLoading: false,
      }));
 
    }
  };
  useEffect(() => {
    logPageView("Tictaktoe ", "Tiktactoe");
  }, []);

  const toogleMenu = () => {
    playClick();
    const hasAnyMove = board?.includes("X") || board?.includes("O");
    if (hasAnyMove) {
    // Show confirmation dialog
    Swal.fire({
      title: 'Exit Game?',
      text: 'Are you sure you want to exit the game? You will lose one of your chances.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#ff4444',
      cancelButtonColor: '#4a90e2',
      confirmButtonText: 'Yes, Exit',
      cancelButtonText: 'Cancel',
      background: 'rgba(0, 0, 0, 0.9)',
      color: '#fff',
      customClass: {
        popup: 'swal2-popup-dark',
        title: 'swal2-title-dark',
        content: 'swal2-content-dark'
      }
    }).then((result) => {
      if (result.isConfirmed) {
        // User confirmed exit, deduct one chance and proceed
        // const newRoundsPlayed = roundsPlayed + 1;
        // setRoundsPlayed(newRoundsPlayed);
        // localStorage.setItem(
        //   `TicTacToeRound_${userId}`,
        //   newRoundsPlayed
        // );
        
        // // Check if user has reached the limit
        // if (newRoundsPlayed >= 3) {
        //   setIsPlayed(true);
        //   localStorage.setItem(
        //     `playedStatusTicToe_${userId}`,
        //     JSON.stringify({ isPlayed: true, date: new Date().toDateString() })
        //   );
        // }
        handleApiResponse("0", () => {
          // Navigate back to task page only after API success
          updateUserInfo((prev) => ({
            ...prev,
            isPlay: false,
            currentComponent: task,
            currentComponentText: "task",
            lastComponent: userDetails?.userDetails.currentComponent,
            lastComponentText: userDetails?.userDetails.currentComponentText,
            isMenu: true,
            menuCount: userDetails?.userDetails?.menuCount + 1,
          }));
        });
      }
      // If user cancels, do nothing (stay in the game)
    });
    }
    else {
      updateUserInfo((prev) => ({
        ...prev,
        isPlay: false,
        currentComponent: task,
        currentComponentText: "task",
        lastComponent: userDetails?.userDetails.currentComponent,
        lastComponentText: userDetails?.userDetails.currentComponentText,
        isMenu: true,
        menuCount: userDetails?.userDetails?.menuCount + 1,
      }));
    }
  };

  const checkWinner = (currentBoard) => {
    const winningCombinations = [
      [0, 1, 2],
      [3, 4, 5],
      [6, 7, 8],
      [0, 3, 6],
      [1, 4, 7],
      [2, 5, 8],
      [0, 4, 8],
      [2, 4, 6],
    ];

    for (let combo of winningCombinations) {
      const [a, b, c] = combo;
      if (
        currentBoard[a] &&
        currentBoard[a] === currentBoard[b] &&
        currentBoard[a] === currentBoard[c]
      ) {
        setWinningCombination(combo); // Save the winning combination
        return currentBoard[a];
      }
    }
    if (!currentBoard.includes(null)) return "Draw"; // Handle draw
    return null;
  };
  useEffect(() => {
    // Get stored data from localStorage
    const storedData = JSON.parse(
      localStorage.getItem(`playedStatusTicToe_${userId}`)
    );
    const today = new Date().toDateString();

    // Check if the stored date matches today's date
    if (storedData?.date === today) {
      setIsPlayed(storedData.isPlayed);
    } else {
      // Reset if the date has changed
      setIsPlayed(false);
      localStorage.setItem(
        `playedStatusTicToe_${userId}`,
        JSON.stringify({ isPlayed: false, date: today })
      );
    }
  }, []);
  const handlePlayerMove = (index) => {
    if (board[index] || winner || gameFinished || roundsPlayed >= 3) return;

    const newBoard = [...board];
    newBoard[index] = "X";
    setBoard(newBoard);
    const result = checkWinner(newBoard);
    if (result) {
      updateUserInfo((prev) => ({
        ...prev,
        isLoading: true,
      }));
      if (result === "X" || result === "O") {
        setTimeout(() => {
          setWinner(result);
          setIsStrikeThrough(true); // Trigger strike-through
        }, 500); // Delay before the strike-through
        setTimeout(() => {
          // setGameFinished(true);
          if (result === "X") {
            setXWins(xWins + 1);
            setScore(userDetails?.earlyUsersLimitReached ? 0 : 2000);
            handleApiResponse(
              userDetails?.earlyUsersLimitReached ? "0" : "2000",
              null
            );
          } else if (result === "O") {
            setOWins(oWins + 1);
            setScore(0);
            handleApiResponse("0", null);
          }
        }, 1500); // Delay before the popup
      } else {
        setWinner(result);
        // setGameFinished(true);
        setScore(0);
        handleApiResponse("0", null);
      }
    } else {
      setIsPlayerTurn(false);
      setTimeout(() => handleComputerMove(newBoard), 600);
    }
  };

  const handleComputerMove = (currentBoard) => {
    if (winner || gameFinished || roundsPlayed >= 3) return;

    const newBoard = [...currentBoard];
    const emptySquares = newBoard
      .map((value, index) => (value === null ? index : null))
      .filter((index) => index !== null);

    const simulateMove = (board, index, player) => {
      const tempBoard = [...board];
      tempBoard[index] = player;
      return checkWinner(tempBoard);
    };

    for (let index of emptySquares) {
      if (simulateMove(newBoard, index, "O") === "O") {
        newBoard[index] = "O";
        setBoard(newBoard);
        setTimeout(() => {
          setWinner("O");
          setIsStrikeThrough(true);
        }, 500);
        setTimeout(() => {
          // setGameFinished(true);
          setOWins(oWins + 1);
          setScore(0);
          handleApiResponse("0", null);
        }, 1500);
        return;
      }
    }

    for (let index of emptySquares) {
      if (simulateMove(newBoard, index, "X") === "X") {
        newBoard[index] = "O";
        setBoard(newBoard);
        setIsPlayerTurn(true);
        return;
      }
    }

    if (newBoard[4] === null) {
      newBoard[4] = "O";
      setBoard(newBoard);
      setIsPlayerTurn(true);
      return;
    }

    const corners = [0, 2, 6, 8];
    for (let corner of corners) {
      if (newBoard[corner] === null) {
        newBoard[corner] = "O";
        setBoard(newBoard);
        setIsPlayerTurn(true);
        return;
      }
    }

    const randomIndex =
      emptySquares[Math.floor(Math.random() * emptySquares.length)];
    newBoard[randomIndex] = "O";
    setBoard(newBoard);
    setIsPlayerTurn(true);
  };

  const resetGame = () => {
    if (roundsPlayed >= 3) return;

    setBoard(Array(9).fill(null));
    setIsPlayerTurn(true);
    setWinner(null);
    setGameFinished(false);
    setWinningCombination([]);
    setIsStrikeThrough(false);
    setRoundsPlayed(Number(roundsPlayed) + 1);
  };

  const getStrikeClass = () => {
    if (!isStrikeThrough || winningCombination.length === 0) return "";
    const [a, b, c] = winningCombination;

    if (a === 0 && b === 1 && c === 2) return "strike-horizontal-top";
    if (a === 3 && b === 4 && c === 5) return "strike-horizontal-middle";
    if (a === 6 && b === 7 && c === 8) return "strike-horizontal-bottom";
    if (a === 0 && b === 3 && c === 6) return "strike-vertical-left";
    if (a === 1 && b === 4 && c === 7) return "strike-vertical-middle";
    if (a === 2 && b === 5 && c === 8) return "strike-vertical-right";
    if (a === 0 && b === 4 && c === 8) return "strike-diagonal-left";
    if (a === 2 && b === 4 && c === 6) return "strike-diagonal-right";

    return "";
  };
  const closePopup = () => {
    setGameFinished(false);
    setWinner(null);
    setIsStrikeThrough(false);
  };
  return (
    <div className="game-container">
      <img
        onClick={() => {
          toogleMenu(task, "task");
        }}
        src="https://d1ccopf5cw1hft.cloudfront.net/s3data/cancelicon.svg"
        className="cancel-imgpoints"
        style={{ cursor: "pointer" }}
      />
      <div className="col-12">
        <h2 className="welcometextmeme">TIC TAC TOE</h2>
        <p className="tic-p">THREE IN A ROW, WIN LIKE A PRO!</p>
      </div>
      <div className={`board ${getStrikeClass()}`}>
        {board.map((cell, index) => (
          <div
            key={index}
            onClick={() =>
              isPlayerTurn && !isPlayed ? handlePlayerMove(index) : null
            }
            className={`cell ${cell ? cell : ""} ${cell ? "filled" : ""}`}
          >
            {cell}
          </div>
        ))}
      </div>

      {/* Game Over Popup */}
      {gameFinished && (
        <div className="overlay">
          <div className="popup">
            <div className="popup-content">
              <h2 className="epic">Game Over!</h2>
              <div className="row text-center">
                <div className="col-12">
                  <div className="epic-div" style={{ padding: "30px 40px" }}>
                    <p className="pointsLabel">TOKENS EARNED</p>
                    <div className="pointsValue1">
                      <img
                        src="https://d1ccopf5cw1hft.cloudfront.net/s3data/coinlogo.png"
                        alt="logo"
                      />
                      <p className="pointsNumber">
                        {!IsPointsReached ? score : 0}
                      </p>
                    </div>
                  </div>
                  <p className="winner-text">
                    {winner === "Draw"
                      ? "It's a draw!"
                      : `Winner: ${winner === "X" ? "You" : "TheMemeTV"}`}
                  </p>
                  {/* <p className="score-text">
                    You Wins: {xWins} | O Wins: {oWins}
                  </p> */}
                </div>
              </div>
            </div>
            <div className="playagain">
              {roundsPlayed >= 2 && gameFinished ? (
                <button className="playgame" onClick={closePopup}>
                  CLOSE
                </button>
              ) : (
                <button className="playgame" onClick={resetGame}>
                  PLAY AGAIN
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Show a message if 3 rounds are completed */}
      {isPlayed && (
        <div className="col-9 ">
          <h3 className="Tic-comeback">Come back tomorrow!</h3>
        </div>
      )}
    </div>
  );
};

export default TicTacToe;
